<template>
  <div>
    <div v-if="content.image">
      <img
        class="img-responsive post-title"
        :src="content.image"
        :alt="content.title"
      >
    </div>

    <div
      v-if="content.textType === 'Marked'"
      style="padding: 20px"
      v-html="compiledMarkdown"
    />
    <div
      v-else-if="content.textType === 'Html'"
      v-html="content.text"
    />
    <div
      v-else-if="content.textType === 'Textuality'"
      style="padding: 20px"
    >
      <p>{{ content.text }}</p>
    </div>
  </div>
</template>

<script>
  import marked from "marked";

  export default {
    name: "QContentLoader",

    props: {
      content: {required: true}
    },

    computed: {
      compiledMarkdown() {
        if (this.content.text)
          return marked(this.content.text, {sanitize: true});
        else
          return '';
      }
    },
  }
</script>

<style scoped>

</style>